import React, { useState, Context, ReactElement, Component } from "react";

export interface records_type {
  kind: string;
  items: records_type_item[];
  totalCount: number;
}

export interface records_type_item {
  // Id: string;
  // Type: string;
  // Name: string;
  // Operate: string;
  // Datacenter: string;
  // Subscription: string;
  // Username: string;
  // Userid: string;
  // Cluster: string;
  // Workspace: string;
  // Namespace: string;
  // Reserve: string;
  // Old: records_old_new_type_item;
  // New: records_old_new_type_item;
  // Description: string;
  // Timestamp: string;
  id: string;
  type: string;
  name: string;
  operate: string;
  datacenter: string;
  subscription: string;
  username: string;
  userid: string;
  cluster: string;
  workspace: string;
  namespace: string;
  reserve: string;
  old: records_old_new_type_item;
  new: records_old_new_type_item;
  description: string;
  timestamp: string;
}

export interface records_old_new_type_item {
    metadata: {
        name: string;
        selfLink: string;
        uid: string;
        resourceVersion: string;
        generation: string;
        creationTimestamp: string;
        labels: object;
        finalizers: string[];
      };
    spec: object;
    status: {
        phase: string;
        oldgeneration: string;
        updatetime: string;
        updateTimeStamp: string;
        oldLabels: object;
    }
}

const RecordsContext: Context<[records_type['items'], React.Dispatch<React.SetStateAction<records_type['items']>>]> = React.createContext<[records_type['items'], React.Dispatch<React.SetStateAction<records_type['items']>>]>([[] as unknown as records_type['items'], (_value: any) => { }]);

const RecordsProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [records, set_records]: [records_type['items'], React.Dispatch<React.SetStateAction<records_type['items']>>] = useState([] as unknown as records_type['items']);
  return (
    <RecordsContext.Provider value={[records, set_records]}>
      {props.children}
    </RecordsContext.Provider>
  )
}

export { RecordsContext, RecordsProvider };
